// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as RegionFlag$PrezzeeRibbon from "./RegionFlag.bs.js";
import * as RegionIndicator$PrezzeeRibbon from "./RegionIndicator.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";
import * as RegionIndicatorFlag$PrezzeeRibbon from "./RegionIndicatorFlag.bs.js";

var inlineRegionPicker = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.smallBody,
      BsCssJs$PrezzeeRibbon.style([
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.alignItems("center")
          ])
    ]);

var Styles = {
  inlineRegionPicker: inlineRegionPicker
};

function RegionIndicatorTextual(props) {
  var text = props.text;
  var onChange = props.onChange;
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var clickableElem = function (r) {
    var flag = JsxRuntime.jsx(RegionFlag$PrezzeeRibbon.make, {
          src: r.flag,
          size: 24
        });
    return JsxRuntime.jsx(RegionIndicatorFlag$PrezzeeRibbon.make, {
                flag: flag,
                text: text
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RegionIndicator$PrezzeeRibbon.make, {
                    regions: props.regions,
                    strings: props.strings,
                    selected: props.selected,
                    children: props.children,
                    clickableElem: clickableElem,
                    onChange: onChange$1
                  }),
              className: inlineRegionPicker
            });
}

var make = RegionIndicatorTextual;

export {
  Styles ,
  make ,
}
/* inlineRegionPicker Not a pure module */
